<template>
  <div class="Advertising">
    <BannerVideo :video-url="$StaticFileUrl + '/mp/video/advertising_banner_2.mp4'">
      <div class="title wow fadeInDown" data-wow-duration="1s">多渠道广告投放平台</div>
      <div class="desc wow fadeInDown" data-wow-duration="1s">对接腾讯、巨星、快手等多渠道广告资源，全时全景覆盖各个使用<br>场景为客户广告营销提供一站式服务，助力客户实现商业目标</div>
      <div class="flex-row flex-col-center">
        <div class="btn-red wow flipInX" data-wow-duration="1s" style="margin-top: 100px">立即咨询</div>
      </div>
    </BannerVideo>
  </div>
</template>

<script>
import WOW from 'wowjs'
import BannerVideo from '@/components/BannerVideo'

/**
 * @author  XuHongli
 * @date  2022/12/28 10:12
 * @version 1.0
 * @description
 */
export default {
  name: 'Advertising',
  components: {BannerVideo},
  mounted() {
    new WOW.WOW().init()
  }
}
</script>

<style scoped>

</style>
